import Vue from 'vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import ElementUI from 'element-ui';
import API from '@/services/API';
import Armazenamento from '@/services/Armazenamento';
import modoRelatorio from   'src/components/Dashboard/Views/Simulacoes/Relatorios/modoRelatorio/modoRelatorio'
import relatorio from '@/services/relatorio'

Vue.use(ElementUI);

export default {
  name: 'PastoComparativoSimplesCtrl',
  components: {
    'modo-relatorio':  modoRelatorio
  },
  data () {
    return {
      loader: false,
      loading: false,
      descricoes: null,
      resultados: [],
      entradas: [],
      lista: [],
      nomeImagemParceiro: null
    }
  },
  methods: {
    pegarDescricao (val) {
      let chave = this.descricoes.items[val];
      if (chave) {
        return chave.titulo;
      } else {
        let result = String(val).replace(/([A-Z])/g, ' $1');
        return result.charAt(0).toUpperCase() + result.slice(1);
      }
    },
    reload () {
      location.reload();
    },
    getInitialValues () {
      const descricoes = API.listar.descricoes()
      return Promise.all([descricoes])
    },
    getSimulation () {
      let lista = this.$router.history.current.params.lista;
      this.lista = lista;
      const indexRelatorioBase = this.lista.findIndex(el => el.simulacaoBase);
      for (let index = 0; index < lista.length; index++) {
        if (index === indexRelatorioBase) {
          this.lista[indexRelatorioBase].simulacao_saida.dados.resultados.lucroLiquidoCabComparativo = '-'
          this.lista[indexRelatorioBase].simulacao_saida.dados.resultados.gmdKgDComparativo = '-'
        } else {
          const relatorioSaidaCurr = this.lista[index].simulacao_saida.dados.resultados;
          const relatorioSaidaBase = this.lista[indexRelatorioBase].simulacao_saida.dados.resultados
          relatorioSaidaCurr.lucroLiquidoCabComparativo = this.calcularComparacao(relatorioSaidaBase.lucroLiquido, relatorioSaidaCurr.lucroLiquido, '100')
          relatorioSaidaCurr.gmdKgDComparativo = this.calcularComparacao(relatorioSaidaBase.gmdKgD, relatorioSaidaCurr.gmdKgD, '1000');
        }
        const relatorioEntradaCurr = lista[index].simulacao_entrada.dados;
        const relatorioSaidaCurr = lista[index].simulacao_saida.dados.resultados;
        relatorioSaidaCurr.ganhoDePesoKG = relatorioEntradaCurr.pesoFinalKg - relatorioEntradaCurr.pesoInicialKg;
        relatorioSaidaCurr.ganhoDePesoArroba = (relatorioSaidaCurr.pesoSaidaArroba - relatorioSaidaCurr.pesoEntradaArroba).toFixed(2)
        relatorioSaidaCurr.pesoSaidaKg = relatorioEntradaCurr.pesoFinalKg;

        this.resultados.push(lista[index].simulacao_saida.dados.resultados);
        this.entradas.push(lista[index].simulacao_entrada.dados);
      }
      this.loading = false;
      this.exportReport()
    },
    calcularComparacao(v1, v2, grandeza) {
      const casasAposVirgula = grandeza.length - 1;
      const v1Formated = Number(v1.replace(/[^0-9.-]/g, '')).toFixed(casasAposVirgula)
      const v2Formated = Number(v2.replace(/[^0-9.-]/g, '')).toFixed(casasAposVirgula)

      const result = v2Formated - v1Formated;
      return result.toLocaleString({
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    exportReport () {
      let doc = relatorio.comparativo.pasto.basico.criar(this)
      let pdfBlob = doc.output('blob')
      this.urlPdf = URL.createObjectURL(pdfBlob);
    },
    downloadReport () {
      let doc = relatorio.comparativo.pasto.basico.criar(this)
      doc.save('comparativo_pasto_basico.pdf')
    },

  },
  created () {
    this.loading = true
    this.getInitialValues().then(([descricoes]) => {
      this.loading = false
      const assinatura = Armazenamento.assinatura.pegar()
      const valor = assinatura && assinatura.valor
      this.nomeImagemParceiro = valor && valor.cupom && valor.cupom.nomeImagemParceiro
      // console.log('Descricoes:')
      // console.log(descricoes)
      this.descricoes = descricoes;
      this.pegarDescricao(0);
      return this.getSimulation();
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Simulacoes/Relatorios/Comparativo/Pasto/SimplesCtrl.js